/* eslint-disable no-shadow */
export enum ActionBehavior {
  ExternalRoute = 'EXTERNAL_ROUTE',
  Route = 'ROUTE',
  Emit = 'EMIT',
  DropDownMenu = 'DROP_DOWN_MENU',
  CrudDetailLink = 'CRUD_DETAIL_LINK', // change the view mode to the detail on the same component without router
  CrudEditLink = 'CRUD_EDIT_LINK', // change the view mode to the edit on the same component without router
  CrudDeleteLink = 'CRUD_DELETE_LINK', // change the view mode to the delete on the same component without router
  CrudCreateLink = 'CRUD_CREATE_LINK', // change the view mode to the create on the same component without router
}
